import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import Link from '@mui/material/Link';

import { DialogTitleWithClose } from 'ui';

const SiteNoticeModal = ({ open, onClose }) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose} maxWidth={false}>
      <DialogTitleWithClose onClose={onClose}>{t('Legal notice')}</DialogTitleWithClose>
      <DialogContent>
        <DialogContentText variant="h6">
          {t(
            'Legal information according to Section 5 TMG (Telemediengesetz – German Telemedia Act)',
          )}
        </DialogContentText>
        <DialogContentText>
          <strong>Scope SE & Co. KGaA</strong>
          <br />
          Lennéstraße 5, 10785 Berlin, Germany
        </DialogContentText>
        <DialogContentText>
          {t('telephone')}: +49 30 27891-0
          <br />
          {t('fax')}: +49 30 27891-100
          <br />
          {t('email')}:{' '}
          <Link href="mailto:servicecentre@scopegroup.com">servicecentre@scopegroup.com</Link>
          <br />
          {t('internet')}:{' '}
          <Link href="https://www.scopegroup.com/" target="_blank">
            www.scopegroup.com
          </Link>
        </DialogContentText>
        <DialogContentText>
          {t(
            'Commercial register of the district court of Berlin-Charlottenburg, register no. HRB 182023 B',
          )}
          <br />
          VAT no.: DE226486027
          <br />
          {t('Chairman of the Supervisory Board: Inès de Dinechin')}
        </DialogContentText>
        <DialogContentText>
          {t('Represented by the general partner Scope Management SE')}
          <br />
          {t(
            'Executive Board: Florian Schoeller (Chairman & CEO), Guillaume Jolivet (CAO), Matthias Böhm (COO), Alexander Bergé (CFO)',
          )}
        </DialogContentText>
        <DialogContentText>
          {t('Chair of the Supervisory Board: Inès de Dinechin')}
          <br />
          {t('Commercial Register Berlin: HRB 178531 B')}
          <br />
        </DialogContentText>
        <DialogContentText>
          <strong>{t('Responsible for the content according to Section 55 (2) RStV')}:</strong>
        </DialogContentText>
        <DialogContentText>
          Florian Schoeller
          <br />
          Scope SE & Co. KGaA
          <br />
          Lennéstraße 5, 10785 Berlin, Germany
        </DialogContentText>
        <DialogContentText>
          <strong>{t('Dispute Settlement')}</strong>
        </DialogContentText>
        <DialogContentText>
          {t('The European Commission provides a platform for online dispute resolution (OS)')}:
          <br />
          <Link href="https://ec.europa.eu/consumers/odr" target="_blank">
            https://ec.europa.eu/consumers/odr
          </Link>
          .<br />
          {t(
            'We are not willing or obliged to participate in dispute resolution proceedings before a consumer arbitration board.',
          )}
        </DialogContentText>
        <DialogContentText>
          <strong>{t('Disclaimer')}</strong>
        </DialogContentText>
        <DialogContentText>
          {t(
            'All information on this website has been carefully checked. We make every effort to continually expand and update the information it contains, but cannot guarantee its completeness, accuracy and complete up-to-dateness. Scope SE & Co. KGaA provides this information without any assurances or warranties of any kind, either express or implied. Scope SE & Co. KGaA excludes all liability for damages arising directly or indirectly from the use of this website, provided they are not based on intent or gross negligence on the part of Scope SE & Co. KGaA. Our websites contain links to other websites. These links serve a purely informational purpose. We have no control over the future development of the content on these linked websites. Therefore, the operators of the linked sites are solely responsible for their content. As a content provider within the meaning of § 7 (1) TMG, Scope SE & Co. KGaA is responsible in accordance with the general laws for its own content which is made available for use on this website. Cross-references (“links”) to content provided by other parties are to be distinguished from this “own” content. By providing such links, Scope SE & Co. KGaA makes third-party content available for use. This external content was checked for possible civil or criminal liability when the link was first created. However, it cannot be ruled out that the content is subsequently changed by its respective provider. Scope SE & Co. KGaA does not constantly review the content it refers to in its offer for changes that could re-establish accountability. If you believe that a linked external site violates applicable law or includes content that is otherwise inappropriate, please let us know.',
          )}
        </DialogContentText>
        <DialogContentText>
          {t(
            'The laws of the Federal Republic of Germany, excluding the United Nations Convention on Contracts for the International Sale of Goods (CISG), shall apply.',
          )}
        </DialogContentText>
        <DialogContentText>
          {t(
            'If the Client is a merchant (Kaufmann) or a legal person under public law or a separate estate (Sondervermögen) under public law or has no general venue in Germany, the exclusive place of jurisdiction for all disputes arising out of or in connection with the use of this website shall be Berlin, Germany.',
          )}
        </DialogContentText>
        <DialogContentText>
          <strong>{t('Copyright')}</strong>
        </DialogContentText>
        <DialogContentText>
          {t(
            'Copyright © 2023 / Business Group ‘’Scope SE & Co. KGaA’’ and its affiliates ‘’Scope Ratings GmbH’’, ‘’Scope Ratings UK Ltd.’’, ‘’Scope Fund Analysis GmbH’’, ‘’Scope Innovation Lab GmbH’ and ‘’Scope ESG Analysis GmbH’’ (also referred to as ,,SCOPE‘‘ or ,,Scope Group‘‘). All rights reserved. All content (text, images, graphics, sound, video and animation files as well as their grouping etc.) on this website is protected by trademark and/or copyright law as well as other protective laws. This legal protection also extends to databases and similar facilities. Unless otherwise expressly permitted, the contents are freely usable only for their intended purpose of being viewed on the Internet. Beyond the limits of copyright law, the content of this website may not be reproduced, disseminated, altered or made accessible to third parties in any form without written permission. Unless otherwise specified, all brand names and logos on this website are trademarked.',
          )}
        </DialogContentText>
      </DialogContent>
    </Dialog>
  );
};

SiteNoticeModal.defaultProps = {
  open: false,
  onClose: () => null,
};

SiteNoticeModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
};

export default SiteNoticeModal;
